<script>
  import moment from "moment";
  import * as _ from "lodash";
  import Popover from "@shared/svelte/Components/Popover/Popover.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Badge from "@shared/svelte/Components/Badge.svelte";
  import ConversationMenu from "./ConversationMenu.svelte";

  export let conversation;
  export let currentConversation;
  export let callbacks;
  export let changeConversationWrapper;

  function activeConvo(h, c) {
    if (!h) {
      return false;
    }
    if (!c) {
      return false;
    }
    let ids1 = _.map(h.sales_reps, function (x) {
      return x.id;
    });
    let ids2 = _.map(c.sales_reps, function (x) {
      return x.id;
    });
    return ids1.filter(x => ids2.includes(x)).length > 0;
  }
  function highlight(conversation) {
    if (!showMenu) {
      highlightedConversation = conversation;
    }
  }
  let showMenu = false;

  function markUnseenWrapper(e) {
    e.stopPropagation();
    showMenu = false;
    callbacks.changeSeen(highlightedConversation, false);
  }

  function closeMenu() {
    showMenu = false;
    highlightedConversation = null;
  }
  let highlightedConversation;

  function makeOrderUrl(conversation) {
    return `/orders?distributors=${conversation.distributors[0].id}`;
  }

</script>

<div
  class={`padding-top--small padding-bottom--small grid-container-middle message-tile ${
    activeConvo(currentConversation, conversation) ? "active" : ""
  }`}
  on:click={() => changeConversationWrapper(conversation)}
  on:mouseenter={() => highlight(conversation)}
  on:mouseleave={() => highlight(null)}
>
  <div id="conversation-{conversation.ids[0]}">
    <div>
      {#if activeConvo(highlightedConversation, conversation)}
        <span class="float-right">
          <Popover
            arrow={false}
            placement="left-center"
            bind:open={showMenu}
            stopPropagation={true}
            overlayColor="rgba(0,0,0,0)"
          >
            <button class="button button--secondary button--smallest float-right" slot="target">
              <Icon type="More" height="20" width="20" color="#0F1924" />
            </button>
            <div slot="content" class="content padding--sm background-white">
              <ConversationMenu
                orderUrl={makeOrderUrl(conversation)}
                {closeMenu}
                {markUnseenWrapper}
                {conversation}
              />
            </div>
          </Popover>
        </span>
      {:else}
        <span class="float-right">
          {#if conversation.last_message}
            <span class="s6 display-inline"
              >{moment(conversation.last_message.created_at).fromNow()}</span
            >
          {/if}

          {#if conversation.num_unseen}
            <span class="margin-left--smaller" id="unseen-{conversation.ids[0]}">
              <Badge>
                {conversation.num_unseen}
              </Badge>
            </span>
          {/if}
        </span>
      {/if}

      <div class="grid-col c12-12 c10-12--md">
        <span class="default-body--bold ellipsis">
          {conversation.sales_reps[0].name}
        </span>
        <span class="default-body--regular">
          {conversation.distributors.map(x => x.name).join(", ")}
        </span>

        <div class="secondary-body--regular ellipsis margin-top--smallest">
          {#if conversation.last_message}
            {conversation.last_message.message}
          {:else}
            <span class="em">No Messages</span>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
